import type { WorkplaceAnalyticsFeatureFlagValue } from "@clipboard-health/flag-backend-main";
import { isNonEmptyArray } from "@clipboard-health/util-ts";

export function canAccessWorkplaceAnalytics(params: {
  flag: WorkplaceAnalyticsFeatureFlagValue;
  hasAdminPrivileges: boolean;
}): boolean {
  const { flag, hasAdminPrivileges } = params;
  return (
    flag.enabled &&
    isNonEmptyArray(flag.tables) &&
    (flag.internalUseOnly ? hasAdminPrivileges : true)
  );
}
